import { useQuery } from "@tanstack/react-query";
import { EMPLOYEES, OPEN_ROLES, RECRUITMENT_FUNNEL } from "@/data/mock";
import { withLatency } from "./simulate";

export async function fetchEmployees() {
  return withLatency(EMPLOYEES);
}

export async function fetchOpenRoles() {
  return withLatency(OPEN_ROLES);
}

export async function fetchRecruitmentFunnel() {
  return withLatency(RECRUITMENT_FUNNEL);
}

export function useEmployees() {
  return useQuery({ queryKey: ["employees"], queryFn: fetchEmployees, staleTime: 60_000 });
}

export function useOpenRoles() {
  return useQuery({ queryKey: ["open-roles"], queryFn: fetchOpenRoles, staleTime: 60_000 });
}

export function useRecruitmentFunnel() {
  return useQuery({ queryKey: ["recruitment-funnel"], queryFn: fetchRecruitmentFunnel, staleTime: 60_000 });
}
